import script from "./TranslationMixin.vue?vue&type=script&lang=js"
export * from "./TranslationMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__